var items = {
  "block.minecraft.air": "lucht",
  "block.minecraft.stone": "steen",
  "block.minecraft.granite": "graniet",
  "block.minecraft.polished_granite": "gepolijst graniet",
  "block.minecraft.diorite": "dioriet",
  "block.minecraft.polished_diorite": "gepolijst dioriet",
  "block.minecraft.andesite": "andesiet",
  "block.minecraft.polished_andesite": "gepolijst andesiet",
  "block.minecraft.grass_block": "grasblok",
  "block.minecraft.dirt": "aarde",
  "block.minecraft.coarse_dirt": "grove aarde",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "helrood nylium",
  "block.minecraft.warped_nylium": "spookachtig nylium",
  "block.minecraft.cobblestone": "keisteen",
  "block.minecraft.oak_planks": "eiken planken",
  "block.minecraft.spruce_planks": "sparren planken",
  "block.minecraft.birch_planks": "berken planken",
  "block.minecraft.jungle_planks": "oerwoud planken",
  "block.minecraft.acacia_planks": "acacia planken",
  "block.minecraft.dark_oak_planks": "donkereiken planken",
  "block.minecraft.crimson_planks": "helrode houten planken",
  "block.minecraft.warped_planks": "spookachtige houten planken",
  "block.minecraft.oak_sapling": "eikenkiemplant",
  "block.minecraft.spruce_sapling": "sparrenkiemplant",
  "block.minecraft.birch_sapling": "berkenkiemplant",
  "block.minecraft.jungle_sapling": "oerwoudkiemplant",
  "block.minecraft.acacia_sapling": "acaciakiemplant",
  "block.minecraft.dark_oak_sapling": "donkereikenkiemplant",
  "block.minecraft.bedrock": "bodemsteen",
  "block.minecraft.sand": "zand",
  "block.minecraft.red_sand": "rode zand",
  "block.minecraft.gravel": "grind",
  "block.minecraft.gold_ore": "gouderts",
  "block.minecraft.iron_ore": "ijzererts",
  "block.minecraft.coal_ore": "steenkool",
  "block.minecraft.nether_gold_ore": "nethergouderts",
  "block.minecraft.oak_log": "eikenstam",
  "block.minecraft.spruce_log": "sparrenstam",
  "block.minecraft.birch_log": "berkenstam",
  "block.minecraft.jungle_log": "oerwoudstam",
  "block.minecraft.acacia_log": "acaciastam",
  "block.minecraft.dark_oak_log": "donkereikenstam",
  "block.minecraft.crimson_stem": "helrode stam",
  "block.minecraft.warped_stem": "spookachtige stam",
  "block.minecraft.stripped_oak_log": "gestripte eikenstam",
  "block.minecraft.stripped_spruce_log": "gestripte sparrenstam",
  "block.minecraft.stripped_birch_log": "gestripte berkenstam",
  "block.minecraft.stripped_jungle_log": "gestripte oerwoudstam",
  "block.minecraft.stripped_acacia_log": "gestripte acaciastam",
  "block.minecraft.stripped_dark_oak_log": "gestripte donkereikenstam",
  "block.minecraft.stripped_crimson_stem": "gestripte helrode stam",
  "block.minecraft.stripped_warped_stem": "gestripte spookachtige stam",
  "block.minecraft.stripped_oak_wood": "gestript eikenhout",
  "block.minecraft.stripped_spruce_wood": "gestript sparrenhout",
  "block.minecraft.stripped_birch_wood": "gestript berkenhout",
  "block.minecraft.stripped_jungle_wood": "gestript oerwoudhout",
  "block.minecraft.stripped_acacia_wood": "gestript acaciahout",
  "block.minecraft.stripped_dark_oak_wood": "gestript donkereikenhout",
  "block.minecraft.stripped_crimson_hyphae": "gestripte helrode schimmeldraden",
  "block.minecraft.stripped_warped_hyphae": "gestripte spookachtige schimmeldraden",
  "block.minecraft.oak_wood": "eikenhout",
  "block.minecraft.spruce_wood": "sparrenhout",
  "block.minecraft.birch_wood": "berkenhout",
  "block.minecraft.jungle_wood": "oerwoudhout",
  "block.minecraft.acacia_wood": "acaciahout",
  "block.minecraft.dark_oak_wood": "donkereikenhout",
  "block.minecraft.crimson_hyphae": "helrode schimmeldraden",
  "block.minecraft.warped_hyphae": "spookachtige schimmeldraden",
  "block.minecraft.oak_leaves": "eikenbladeren",
  "block.minecraft.spruce_leaves": "sparrenbladeren",
  "block.minecraft.birch_leaves": "berkenbladeren",
  "block.minecraft.jungle_leaves": "oerwoudbladeren",
  "block.minecraft.acacia_leaves": "acaciabladeren",
  "block.minecraft.dark_oak_leaves": "donkereikenbladeren",
  "block.minecraft.sponge": "spons",
  "block.minecraft.wet_sponge": "natte spons",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapis lazuli-erts",
  "block.minecraft.lapis_block": "lapis lazuliblok",
  "block.minecraft.dispenser": "uitwerper",
  "block.minecraft.sandstone": "zandsteen",
  "block.minecraft.chiseled_sandstone": "gebeiteld zandsteen",
  "block.minecraft.cut_sandstone": "gesneden zandsteen",
  "block.minecraft.note_block": "nootblok",
  "block.minecraft.powered_rail": "aandrijfspoor",
  "block.minecraft.detector_rail": "detectiespoor",
  "block.minecraft.sticky_piston": "kleefzuiger",
  "block.minecraft.cobweb": "spinnenweb",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "varen",
  "block.minecraft.dead_bush": "dode struik",
  "block.minecraft.seagrass": "zeegras",
  "block.minecraft.sea_pickle": "zeeaurgurk",
  "block.minecraft.piston": "zuiger",
  "block.minecraft.white_wool": "witte wol",
  "block.minecraft.orange_wool": "oranje wol",
  "block.minecraft.magenta_wool": "magenta wol",
  "block.minecraft.light_blue_wool": "lichtblauwe wol",
  "block.minecraft.yellow_wool": "gele wol",
  "block.minecraft.lime_wool": "limoengroen wol",
  "block.minecraft.pink_wool": "roze wol",
  "block.minecraft.gray_wool": "grijze wol",
  "block.minecraft.light_gray_wool": "lichtgrijze wol",
  "block.minecraft.cyan_wool": "cyaan wol",
  "block.minecraft.purple_wool": "paarse wol",
  "block.minecraft.blue_wool": "blauwe wol",
  "block.minecraft.brown_wool": "bruine wol",
  "block.minecraft.green_wool": "groene wol",
  "block.minecraft.red_wool": "rode wol",
  "block.minecraft.black_wool": "zwarte wol",
  "block.minecraft.dandelion": "paardenbloem",
  "block.minecraft.poppy": "klaproos",
  "block.minecraft.blue_orchid": "blauwe orchidee",
  "block.minecraft.allium": "look",
  "block.minecraft.azure_bluet": "porseleinsterretje",
  "block.minecraft.red_tulip": "rode tulp",
  "block.minecraft.orange_tulip": "oranje tulp",
  "block.minecraft.white_tulip": "witte tulp",
  "block.minecraft.pink_tulip": "roze tulp",
  "block.minecraft.oxeye_daisy": "madeliefje",
  "block.minecraft.cornflower": "korenbloem",
  "block.minecraft.lily_of_the_valley": "lelietjes-der-dalen",
  "block.minecraft.wither_rose": "witherroos",
  "block.minecraft.brown_mushroom": "bruine paddenstoel",
  "block.minecraft.red_mushroom": "rode paddenstoel",
  "block.minecraft.crimson_fungus": "helrode zwam",
  "block.minecraft.warped_fungus": "spookachtige zwam",
  "block.minecraft.crimson_roots": "helrode wortels",
  "block.minecraft.warped_roots": "spookachtige wortels",
  "block.minecraft.nether_sprouts": "netherscheuten",
  "block.minecraft.weeping_vines": "hangende klimop",
  "block.minecraft.twisting_vines": "verwikkelde klimop",
  "block.minecraft.sugar_cane": "suikerriet",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboe",
  "block.minecraft.gold_block": "goudblok",
  "block.minecraft.iron_block": "ijzerblok",
  "block.minecraft.oak_slab": "eiken plaat",
  "block.minecraft.spruce_slab": "sparren plaat",
  "block.minecraft.birch_slab": "berken plaat",
  "block.minecraft.jungle_slab": "oerwoud plaat",
  "block.minecraft.acacia_slab": "acacia plaat",
  "block.minecraft.dark_oak_slab": "donkereiken plaat",
  "block.minecraft.crimson_slab": "helrode houten plaat",
  "block.minecraft.warped_slab": "spookachtige houten plaat",
  "block.minecraft.stone_slab": "stenen plaat",
  "block.minecraft.smooth_stone_slab": "gladde stenen plaat",
  "block.minecraft.sandstone_slab": "zandstenen plaat",
  "block.minecraft.cut_sandstone_slab": "gesneden zandstenen plaat",
  "block.minecraft.petrified_oak_slab": "versteende eiken plaat",
  "block.minecraft.cobblestone_slab": "keistenen plaat",
  "block.minecraft.brick_slab": "bakstenen plaat",
  "block.minecraft.stone_brick_slab": "blokstenen plaat",
  "block.minecraft.nether_brick_slab": "netherbakstenen plaat",
  "block.minecraft.quartz_slab": "kwartsplaat",
  "block.minecraft.red_sandstone_slab": "rode zandstenen plaat",
  "block.minecraft.cut_red_sandstone_slab": "gesneden rode zandstenen plaat",
  "block.minecraft.purpur_slab": "purpurplaat",
  "block.minecraft.prismarine_slab": "prismarienplaat",
  "block.minecraft.prismarine_brick_slab": "prismarienblokstenen plaat",
  "block.minecraft.dark_prismarine_slab": "donkerprismarienplaat",
  "block.minecraft.smooth_quartz": "glad kwartsblok",
  "block.minecraft.smooth_red_sandstone": "glad rood zandsteen",
  "block.minecraft.smooth_sandstone": "glad zandsteen",
  "block.minecraft.smooth_stone": "gladde steen",
  "block.minecraft.bricks": "bakstenen",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "boekenkast",
  "block.minecraft.mossy_cobblestone": "mossige keisteen",
  "block.minecraft.obsidian": "obsidiaan",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "endstaf",
  "block.minecraft.chorus_plant": "chorusplant",
  "block.minecraft.chorus_flower": "chorusbloem",
  "block.minecraft.purpur_block": "purpurblok",
  "block.minecraft.purpur_pillar": "purpurpilaar",
  "block.minecraft.purpur_stairs": "purpurtrap",
  "block.minecraft.spawner": "monsterkooi",
  "block.minecraft.oak_stairs": "eiken trap",
  "block.minecraft.chest": "kist",
  "block.minecraft.diamond_ore": "diamanterts",
  "block.minecraft.diamond_block": "diamantblok",
  "block.minecraft.crafting_table": "werkbank",
  "block.minecraft.farmland": "akkerland",
  "block.minecraft.furnace": "oven",
  "block.minecraft.ladder": "ladder",
  "block.minecraft.rail": "spoor",
  "block.minecraft.cobblestone_stairs": "keistenen trap",
  "block.minecraft.lever": "hendel",
  "block.minecraft.stone_pressure_plate": "stenen drunkplaat",
  "block.minecraft.oak_pressure_plate": "eiken drukplaat",
  "block.minecraft.spruce_pressure_plate": "sparren drukplaat",
  "block.minecraft.birch_pressure_plate": "berken drukplaat",
  "block.minecraft.jungle_pressure_plate": "oerwoud drukplaat",
  "block.minecraft.acacia_pressure_plate": "acacia drukplaat",
  "block.minecraft.dark_oak_pressure_plate": "donkereiken drukplaat",
  "block.minecraft.crimson_pressure_plate": "helrode houten drukplaat",
  "block.minecraft.warped_pressure_plate": "spookachtige houten drukplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "gepolijste zwartstenen drukplaat",
  "block.minecraft.redstone_ore": "redstone erts",
  "block.minecraft.redstone_torch": "redstonefakkel",
  "block.minecraft.snow": "sneeuw",
  "block.minecraft.ice": "ijs",
  "block.minecraft.snow_block": "sneeuwblok",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "klei",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "eikenhouten hek",
  "block.minecraft.spruce_fence": "sparrenhouten hek",
  "block.minecraft.birch_fence": "berkenhouten hek",
  "block.minecraft.jungle_fence": "oerwoudhouten hek",
  "block.minecraft.acacia_fence": "acaciahouten hek",
  "block.minecraft.dark_oak_fence": "donkereikenhouten hek",
  "block.minecraft.crimson_fence": "helrood houten hek",
  "block.minecraft.warped_fence": "spookachtig houten hek",
  "block.minecraft.pumpkin": "pompoen",
  "block.minecraft.carved_pumpkin": "bewerkte pompoen",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "zielenzand",
  "block.minecraft.soul_soil": "zielenaarde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "gepolijst basalt",
  "block.minecraft.soul_torch": "zielenfakkel",
  "block.minecraft.glowstone": "gloeisteen",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "eiken valluik",
  "block.minecraft.spruce_trapdoor": "sparren valluik",
  "block.minecraft.birch_trapdoor": "berken valluik",
  "block.minecraft.jungle_trapdoor": "oerwoud valluik",
  "block.minecraft.acacia_trapdoor": "acacia valluik",
  "block.minecraft.dark_oak_trapdoor": "donkereiken valluik",
  "block.minecraft.crimson_trapdoor": "helrood houten valluik",
  "block.minecraft.warped_trapdoor": "spookachtig houten valluik",
  "block.minecraft.infested_stone": "geïnfecteerde steen",
  "block.minecraft.infested_cobblestone": "geïnfecteerde keisteen",
  "block.minecraft.infested_stone_bricks": "geïnfecteerde blokstenen",
  "block.minecraft.infested_mossy_stone_bricks": "geïnfecteerde mossige blokstenen",
  "block.minecraft.infested_cracked_stone_bricks": "geïnfecteerde gebarsten blokstenen",
  "block.minecraft.infested_chiseled_stone_bricks": "geïnfecteerde gebeitelde blokstenen",
  "block.minecraft.stone_bricks": "blokstenen",
  "block.minecraft.mossy_stone_bricks": "mossige blokstenen",
  "block.minecraft.cracked_stone_bricks": "gebarsten blokstenen",
  "block.minecraft.chiseled_stone_bricks": "gebeitelde blokstenen",
  "block.minecraft.brown_mushroom_block": "bruin paddenstoelenblok",
  "block.minecraft.red_mushroom_block": "rood paddenstoelenblok",
  "block.minecraft.mushroom_stem": "paddenstoelenstam",
  "block.minecraft.iron_bars": "tralies",
  "block.minecraft.chain": "ketting",
  "block.minecraft.glass_pane": "glazen ruit",
  "block.minecraft.melon": "meloen",
  "block.minecraft.vine": "lianen",
  "block.minecraft.oak_fence_gate": "eikenhouten poort",
  "block.minecraft.spruce_fence_gate": "sparrenhouten poort",
  "block.minecraft.birch_fence_gate": "berkenhouten poort",
  "block.minecraft.jungle_fence_gate": "oerwoudhouten poort",
  "block.minecraft.acacia_fence_gate": "acaciahouten poort",
  "block.minecraft.dark_oak_fence_gate": "donkereikenhouten poort",
  "block.minecraft.crimson_fence_gate": "helrode houten poort",
  "block.minecraft.warped_fence_gate": "spookachtige houten poort",
  "block.minecraft.brick_stairs": "bakstenen trap",
  "block.minecraft.stone_brick_stairs": "blokstenen trap",
  "block.minecraft.mycelium": "zwamvlok",
  "block.minecraft.lily_pad": "waterlelie",
  "block.minecraft.nether_bricks": "netherbakstenen",
  "block.minecraft.cracked_nether_bricks": "gebarsten netherbakstenen",
  "block.minecraft.chiseled_nether_bricks": "gebeitelde netherbakstenen",
  "block.minecraft.nether_brick_fence": "netherbakstenen hek",
  "block.minecraft.nether_brick_stairs": "netherbakstenen trap",
  "block.minecraft.enchanting_table": "betoveringstafel",
  "block.minecraft.end_portal_frame": "endportaalframe",
  "block.minecraft.end_stone": "endsteen",
  "block.minecraft.end_stone_bricks": "endblokstenen",
  "block.minecraft.dragon_egg": "drakenei",
  "block.minecraft.redstone_lamp": "redstonelamp",
  "block.minecraft.sandstone_stairs": "zandstenen trap",
  "block.minecraft.emerald_ore": "smaragderts",
  "block.minecraft.ender_chest": "enderkist",
  "block.minecraft.tripwire_hook": "struikeldraad haak",
  "block.minecraft.emerald_block": "smaragdblok",
  "block.minecraft.spruce_stairs": "sparren trap",
  "block.minecraft.birch_stairs": "berken trap",
  "block.minecraft.jungle_stairs": "oerwoud trap",
  "block.minecraft.crimson_stairs": "helrode houten trap",
  "block.minecraft.warped_stairs": "spookachtige houten trap",
  "block.minecraft.command_block": "opdrachtblok",
  "block.minecraft.beacon": "baken",
  "block.minecraft.cobblestone_wall": "keistenen muur",
  "block.minecraft.mossy_cobblestone_wall": "mossige keistenen muur",
  "block.minecraft.brick_wall": "bakstenen muur",
  "block.minecraft.prismarine_wall": "prismarienmuur",
  "block.minecraft.red_sandstone_wall": "rode zandstenen muur",
  "block.minecraft.mossy_stone_brick_wall": "mossige blokstenen muur",
  "block.minecraft.granite_wall": "granieten muur",
  "block.minecraft.stone_brick_wall": "blokstenen muur",
  "block.minecraft.nether_brick_wall": "netherbakstenen muur",
  "block.minecraft.andesite_wall": "andesietenmuur",
  "block.minecraft.red_nether_brick_wall": "rode netherbakstenen muur",
  "block.minecraft.sandstone_wall": "zandstenen muur",
  "block.minecraft.end_stone_brick_wall": "endblokstenen muur",
  "block.minecraft.diorite_wall": "diorietenmuur",
  "block.minecraft.blackstone_wall": "zwartstenen muur",
  "block.minecraft.polished_blackstone_wall": "gepolijste zwartstenen muur",
  "block.minecraft.polished_blackstone_brick_wall": "gepolijste zwartstenen blokstenen muur",
  "block.minecraft.stone_button": "stenen knop",
  "block.minecraft.oak_button": "eiken knop",
  "block.minecraft.spruce_button": "sparren knop",
  "block.minecraft.birch_button": "berken knop",
  "block.minecraft.jungle_button": "oerwoud knop",
  "block.minecraft.acacia_button": "acacia knop",
  "block.minecraft.dark_oak_button": "donkereiken knop",
  "block.minecraft.crimson_button": "helrode houten knop",
  "block.minecraft.warped_button": "spookachtige houten knop",
  "block.minecraft.polished_blackstone_button": "gepolijste zwartstenen knop",
  "block.minecraft.anvil": "aanvil",
  "block.minecraft.chipped_anvil": "gebarsten aanvil",
  "block.minecraft.damaged_anvil": "beschadigd aanvil",
  "block.minecraft.trapped_chest": "kist met valstrik",
  "block.minecraft.light_weighted_pressure_plate": "lichte drukgevoelige plaat",
  "block.minecraft.heavy_weighted_pressure_plate": "zware drukgevoelige plaat",
  "block.minecraft.daylight_detector": "daglichtsensor",
  "block.minecraft.redstone_block": "redstoneblok",
  "block.minecraft.nether_quartz_ore": "netherkwartserts",
  "block.minecraft.hopper": "trechter",
  "block.minecraft.chiseled_quartz_block": "gebeiteld kwartsblok",
  "block.minecraft.quartz_block": "kwartsblok",
  "block.minecraft.quartz_bricks": "kwartsblokstenen",
  "block.minecraft.quartz_pillar": "kwartspilaar",
  "block.minecraft.quartz_stairs": "kwartstrap",
  "block.minecraft.activator_rail": "activatiespoor",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "wit terracotta",
  "block.minecraft.orange_terracotta": "oranje terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "lichtblauw terracotta",
  "block.minecraft.yellow_terracotta": "geel terracotta",
  "block.minecraft.lime_terracotta": "limoengroene terracotta",
  "block.minecraft.pink_terracotta": "roze terracotta",
  "block.minecraft.gray_terracotta": "grijs terracotta",
  "block.minecraft.light_gray_terracotta": "lichtgrijs terracotta",
  "block.minecraft.cyan_terracotta": "cyaan terracotta",
  "block.minecraft.purple_terracotta": "paars terracotta",
  "block.minecraft.blue_terracotta": "blauw terracotta",
  "block.minecraft.brown_terracotta": "bruin terracotta",
  "block.minecraft.green_terracotta": "groen terracotta",
  "block.minecraft.red_terracotta": "rood terracotta",
  "block.minecraft.black_terracotta": "zwart terracotta",
  "block.minecraft.barrier": "barrière",
  "block.minecraft.iron_trapdoor": "ijzeren valluik",
  "block.minecraft.hay_block": "hooibaal",
  "block.minecraft.white_carpet": "wit tapijt",
  "block.minecraft.orange_carpet": "oranje tapijt",
  "block.minecraft.magenta_carpet": "magenta tapijt",
  "block.minecraft.light_blue_carpet": "lichtblauw tapijt",
  "block.minecraft.yellow_carpet": "geel tapijt",
  "block.minecraft.lime_carpet": "limoengroen tapijt",
  "block.minecraft.pink_carpet": "roze tapijt",
  "block.minecraft.gray_carpet": "grijs tapijt",
  "block.minecraft.light_gray_carpet": "lichtgrijs tapijt",
  "block.minecraft.cyan_carpet": "cyaan tapijt",
  "block.minecraft.purple_carpet": "paars tapijt",
  "block.minecraft.blue_carpet": "blauw tapijt",
  "block.minecraft.brown_carpet": "bruin tapijt",
  "block.minecraft.green_carpet": "groen tapijt",
  "block.minecraft.red_carpet": "rood tapijt",
  "block.minecraft.black_carpet": "zwart tapijt",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "steenkoolblok",
  "block.minecraft.packed_ice": "pakijs",
  "block.minecraft.acacia_stairs": "acacia trap",
  "block.minecraft.dark_oak_stairs": "donkereiken trap",
  "block.minecraft.slime_block": "slijmblok",
  "block.minecraft.grass_path": "graspad",
  "block.minecraft.sunflower": "zonnebloem",
  "block.minecraft.lilac": "sering",
  "block.minecraft.rose_bush": "rozenstruik",
  "block.minecraft.peony": "pioenroos",
  "block.minecraft.tall_grass": "hoog gras",
  "block.minecraft.large_fern": "grote varen",
  "block.minecraft.white_stained_glass": "witgekleurd glas",
  "block.minecraft.orange_stained_glass": "oranjegekleurd glas",
  "block.minecraft.magenta_stained_glass": "magentagekleurd glas",
  "block.minecraft.light_blue_stained_glass": "lichtblauwgekleurd glas",
  "block.minecraft.yellow_stained_glass": "geelgekleurd glas",
  "block.minecraft.lime_stained_glass": "limoengroengekleurd glas",
  "block.minecraft.pink_stained_glass": "rozegekleurd glas",
  "block.minecraft.gray_stained_glass": "grijsgekleurd glas",
  "block.minecraft.light_gray_stained_glass": "lichtgrijsgekleurd glas",
  "block.minecraft.cyan_stained_glass": "cyaangekleurd glas",
  "block.minecraft.purple_stained_glass": "paarsgekleurd glas",
  "block.minecraft.blue_stained_glass": "blauwgekleurd glas",
  "block.minecraft.brown_stained_glass": "bruingekleurd glas",
  "block.minecraft.green_stained_glass": "groengekleurd glas",
  "block.minecraft.red_stained_glass": "roodgekleurd glas",
  "block.minecraft.black_stained_glass": "zwartgekleurd glas",
  "block.minecraft.white_stained_glass_pane": "witgekleurde glazen ruit",
  "block.minecraft.orange_stained_glass_pane": "oranjegekleurde glazen ruit",
  "block.minecraft.magenta_stained_glass_pane": "magentagekleurde glazen ruit",
  "block.minecraft.light_blue_stained_glass_pane": "lichtblauwgekleurde glazen ruit",
  "block.minecraft.yellow_stained_glass_pane": "geelgekleurde glazen ruit",
  "block.minecraft.lime_stained_glass_pane": "limoengroengekleurde glazen ruit",
  "block.minecraft.pink_stained_glass_pane": "rozegekleurde glazen ruit",
  "block.minecraft.gray_stained_glass_pane": "grijsgekleurde glazen ruit",
  "block.minecraft.light_gray_stained_glass_pane": "lichtgrijsgekleurde glazen ruit",
  "block.minecraft.cyan_stained_glass_pane": "cyaangekleurde glazen ruit",
  "block.minecraft.purple_stained_glass_pane": "paarsgekleurde glazen ruit",
  "block.minecraft.blue_stained_glass_pane": "blauwgekleurde glazen ruit",
  "block.minecraft.brown_stained_glass_pane": "bruingekleurde glazen ruit",
  "block.minecraft.green_stained_glass_pane": "groengekleurde glazen ruit",
  "block.minecraft.red_stained_glass_pane": "roodgekleurde glazen ruit",
  "block.minecraft.black_stained_glass_pane": "zwartgekleurde glazen ruit",
  "block.minecraft.prismarine": "prismarien",
  "block.minecraft.prismarine_bricks": "prismarienblokstenen",
  "block.minecraft.dark_prismarine": "donkerprismarien",
  "block.minecraft.prismarine_stairs": "prismarientrap",
  "block.minecraft.prismarine_brick_stairs": "prismarienblokstenen trap",
  "block.minecraft.dark_prismarine_stairs": "donkerprismarientrap",
  "block.minecraft.sea_lantern": "zeelantaarn",
  "block.minecraft.red_sandstone": "rood zandsteen",
  "block.minecraft.chiseled_red_sandstone": "gebeiteld rood zandsteen",
  "block.minecraft.cut_red_sandstone": "gesneden rood zandsteen",
  "block.minecraft.red_sandstone_stairs": "rode zandstenen trap",
  "block.minecraft.repeating_command_block": "herhalend opdrachtblok",
  "block.minecraft.chain_command_block": "gekoppeld opdrachtblok",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "netherkruidblok",
  "block.minecraft.warped_wart_block": "spookachtig kruidblok",
  "block.minecraft.red_nether_bricks": "rode netherbakstenen",
  "block.minecraft.bone_block": "bottenblok",
  "block.minecraft.structure_void": "structuurleegte",
  "block.minecraft.observer": "observeerder",
  "block.minecraft.shulker_box": "shulkerdoos",
  "block.minecraft.white_shulker_box": "witte shulkerdoos",
  "block.minecraft.orange_shulker_box": "oranje shulkerdoos",
  "block.minecraft.magenta_shulker_box": "magenta shulkerdoos",
  "block.minecraft.light_blue_shulker_box": "lichtblauwe shulkerdoos",
  "block.minecraft.yellow_shulker_box": "gele shulkerdoos",
  "block.minecraft.lime_shulker_box": "limoengroene shulkerdoos",
  "block.minecraft.pink_shulker_box": "roze shulkerdoos",
  "block.minecraft.gray_shulker_box": "grijze shulkerdoos",
  "block.minecraft.light_gray_shulker_box": "lichtgrijze shulkerdoos",
  "block.minecraft.cyan_shulker_box": "cyaan shulkerdoos",
  "block.minecraft.purple_shulker_box": "paarse shulkerdoos",
  "block.minecraft.blue_shulker_box": "blauwe shulkerdoos",
  "block.minecraft.brown_shulker_box": "bruine shulkerdoos",
  "block.minecraft.green_shulker_box": "groene shulkerdoos",
  "block.minecraft.red_shulker_box": "rode shulkerdoos",
  "block.minecraft.black_shulker_box": "zwarte shulkerdoos",
  "block.minecraft.white_glazed_terracotta": "witgeglazuurde terracotte",
  "block.minecraft.orange_glazed_terracotta": "oranjegeglazuurde terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magentageglazuurde terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "lichtblauwgeglazuurde terracotta",
  "block.minecraft.yellow_glazed_terracotta": "geelgeglazuurde terracotta",
  "block.minecraft.lime_glazed_terracotta": "limoengroengeglazuurde terracotta",
  "block.minecraft.pink_glazed_terracotta": "rozegeglazuurde terracotta",
  "block.minecraft.gray_glazed_terracotta": "grijsgeglazuurde terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "lichtgrijsgeglazuurde terracotta",
  "block.minecraft.cyan_glazed_terracotta": "cyaangeglazuurde terracotta",
  "block.minecraft.purple_glazed_terracotta": "paarsgeglazuurde terracotta",
  "block.minecraft.blue_glazed_terracotta": "blauwgeglazuurde terracotta",
  "block.minecraft.brown_glazed_terracotta": "bruingeglazuurde terracotta",
  "block.minecraft.green_glazed_terracotta": "groengeglazuurde terracotta",
  "block.minecraft.red_glazed_terracotta": "roodgeglazuurde terracotta",
  "block.minecraft.black_glazed_terracotta": "zwartgeglazuurde terracotta",
  "block.minecraft.white_concrete": "wit beton",
  "block.minecraft.orange_concrete": "oranje beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "lichtblauw beton",
  "block.minecraft.yellow_concrete": "geel beton",
  "block.minecraft.lime_concrete": "limoengroen beton",
  "block.minecraft.pink_concrete": "roze beton",
  "block.minecraft.gray_concrete": "grijs beton",
  "block.minecraft.light_gray_concrete": "lichtgrijs beton",
  "block.minecraft.cyan_concrete": "cyaan beton",
  "block.minecraft.purple_concrete": "paars beton",
  "block.minecraft.blue_concrete": "blauw beton",
  "block.minecraft.brown_concrete": "bruin beton",
  "block.minecraft.green_concrete": "groen beton",
  "block.minecraft.red_concrete": "rood beton",
  "block.minecraft.black_concrete": "zwart beton",
  "block.minecraft.white_concrete_powder": "wit cement",
  "block.minecraft.orange_concrete_powder": "oranje cement",
  "block.minecraft.magenta_concrete_powder": "magenta cement",
  "block.minecraft.light_blue_concrete_powder": "lichtblauw cement",
  "block.minecraft.yellow_concrete_powder": "geel cement",
  "block.minecraft.lime_concrete_powder": "limoengroen cement",
  "block.minecraft.pink_concrete_powder": "roze cement",
  "block.minecraft.gray_concrete_powder": "grijs cement",
  "block.minecraft.light_gray_concrete_powder": "lichtgrijs cement",
  "block.minecraft.cyan_concrete_powder": "cyaan cement",
  "block.minecraft.purple_concrete_powder": "paars cement",
  "block.minecraft.blue_concrete_powder": "blauw cement",
  "block.minecraft.brown_concrete_powder": "bruin cement",
  "block.minecraft.green_concrete_powder": "groen cement",
  "block.minecraft.red_concrete_powder": "rood cement",
  "block.minecraft.black_concrete_powder": "zwart cement",
  "block.minecraft.turtle_egg": "schildpadei",
  "block.minecraft.dead_tube_coral_block": "dood buiskoraalblok",
  "block.minecraft.dead_brain_coral_block": "dood hersenkoraalblok",
  "block.minecraft.dead_bubble_coral_block": "dood blaaskoraalblok",
  "block.minecraft.dead_fire_coral_block": "dood brandkoraalblok",
  "block.minecraft.dead_horn_coral_block": "dood hoornkoraalblok",
  "block.minecraft.tube_coral_block": "buiskoraalblok",
  "block.minecraft.brain_coral_block": "hersenkoraalblok",
  "block.minecraft.bubble_coral_block": "blaaskoraalblok",
  "block.minecraft.fire_coral_block": "brandkoraalblok",
  "block.minecraft.horn_coral_block": "hoornkoraalblok",
  "block.minecraft.tube_coral": "buiskoraal",
  "block.minecraft.brain_coral": "hersenkoraal",
  "block.minecraft.bubble_coral": "blaaskoraal",
  "block.minecraft.fire_coral": "brandkoraal",
  "block.minecraft.horn_coral": "hoornkoraal",
  "block.minecraft.dead_brain_coral": "dood hersenkoraal",
  "block.minecraft.dead_bubble_coral": "dood blaaskoraal",
  "block.minecraft.dead_fire_coral": "dood brandkoraal",
  "block.minecraft.dead_horn_coral": "dood hoornkoraal",
  "block.minecraft.dead_tube_coral": "dood buiskoraal",
  "block.minecraft.tube_coral_fan": "buiskoraalwaaier",
  "block.minecraft.brain_coral_fan": "hersenkoraalwaaier",
  "block.minecraft.bubble_coral_fan": "blaaskoraalwaaier",
  "block.minecraft.fire_coral_fan": "brandkoraalwaaier",
  "block.minecraft.horn_coral_fan": "hoornkoraalwaaier",
  "block.minecraft.dead_tube_coral_fan": "dode buiskoraalwaaier",
  "block.minecraft.dead_brain_coral_fan": "dode hersenkoraalwaaier",
  "block.minecraft.dead_bubble_coral_fan": "dode blaaskoraalwaaier",
  "block.minecraft.dead_fire_coral_fan": "dode brandkoraalwaaier",
  "block.minecraft.dead_horn_coral_fan": "dode hoornkoraalwaaier",
  "block.minecraft.blue_ice": "blauw ijs",
  "block.minecraft.conduit": "kracht van de zee",
  "block.minecraft.polished_granite_stairs": "gepolijste granieten trap",
  "block.minecraft.smooth_red_sandstone_stairs": "gladde rode zandstenen trap",
  "block.minecraft.mossy_stone_brick_stairs": "mossige blokstenen trap",
  "block.minecraft.polished_diorite_stairs": "gepolijste dioriettrap",
  "block.minecraft.mossy_cobblestone_stairs": "mossige keistenen trap",
  "block.minecraft.end_stone_brick_stairs": "endblokstenen trap",
  "block.minecraft.stone_stairs": "stenen trap",
  "block.minecraft.smooth_sandstone_stairs": "gladde zandstenen trap",
  "block.minecraft.smooth_quartz_stairs": "gladde kwartstrap",
  "block.minecraft.granite_stairs": "graniettrap",
  "block.minecraft.andesite_stairs": "andesiettrap",
  "block.minecraft.red_nether_brick_stairs": "rode netherbakstenen trap",
  "block.minecraft.polished_andesite_stairs": "gepolijst andesiettrap",
  "block.minecraft.diorite_stairs": "dioriettrap",
  "block.minecraft.polished_granite_slab": "gepolijste granietplaat",
  "block.minecraft.smooth_red_sandstone_slab": "gladde rode zandstenen plaat",
  "block.minecraft.mossy_stone_brick_slab": "mossige blokstenen plaat",
  "block.minecraft.polished_diorite_slab": "gepolijste diorietplaat",
  "block.minecraft.mossy_cobblestone_slab": "mossige keistenen plaat",
  "block.minecraft.end_stone_brick_slab": "endblokstenen plaat",
  "block.minecraft.smooth_sandstone_slab": "gladde zandstenen plaat",
  "block.minecraft.smooth_quartz_slab": "gladde kwartsplaat",
  "block.minecraft.granite_slab": "granietplaat",
  "block.minecraft.andesite_slab": "andesietplaat",
  "block.minecraft.red_nether_brick_slab": "rode netherbakstenen plaat",
  "block.minecraft.polished_andesite_slab": "gepolijst andesietplaat",
  "block.minecraft.diorite_slab": "diorietplaat",
  "block.minecraft.scaffolding": "stelling",
  "block.minecraft.iron_door": "ijzeren deur",
  "block.minecraft.oak_door": "eiken deur",
  "block.minecraft.spruce_door": "sparren deur",
  "block.minecraft.birch_door": "berken deur",
  "block.minecraft.jungle_door": "oerwoud deur",
  "block.minecraft.acacia_door": "acacia deur",
  "block.minecraft.dark_oak_door": "donkereiken deur",
  "block.minecraft.crimson_door": "helrode houten deur",
  "block.minecraft.warped_door": "spookachtige houten deur",
  "block.minecraft.repeater": "redstoneversterker",
  "block.minecraft.comparator": "redstonevergelijker",
  "block.minecraft.structure_block": "structuurblok",
  "block.minecraft.jigsaw": "puzzelblok",
  "item.minecraft.turtle_helmet": "schildpadschild□□wanneer op het hoofd:□+2 harnas",
  "item.minecraft.scute": "hoornschild",
  "item.minecraft.iron_shovel": "ijzeren schup□□wanneer in hoofdhand:□+3.5 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.iron_pickaxe": "ijzeren houweel□□wanneer in hoofdhand:□+3 aanvalsschade□-2.8 aanvalssnelheid",
  "item.minecraft.iron_axe": "ijzeren bijl□□wanneer in hoofdhand:□+8 aanvalsschade□-3.1 aanvalssnelheid",
  "item.minecraft.flint_and_steel": "vuursteen en staal",
  "item.minecraft.apple": "appel",
  "item.minecraft.bow": "boog",
  "item.minecraft.arrow": "pijl",
  "item.minecraft.coal": "steenkool",
  "item.minecraft.charcoal": "houtskool",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "ijzerstaaf",
  "item.minecraft.gold_ingot": "goudstaaf",
  "item.minecraft.netherite_ingot": "netherietstaaf",
  "item.minecraft.netherite_scrap": "netherietschroot",
  "item.minecraft.iron_sword": "ijzeren zwaard□□wanneer in hoofdhand:□+5 aanvalsschade□-2.4 aanvalssnelheid",
  "item.minecraft.wooden_sword": "houten zwaard□□wanneer in hoofdhand:□+3 aanvalsschade□-2.4 aanvalssnelheid",
  "item.minecraft.wooden_shovel": "houten schup□□wanneer in hoofdhand:□+1.5 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.wooden_pickaxe": "houten houweel□□wanneer in hoofdhand:□+1 aanvalsschade□-2.8 aanvalssnelheid",
  "item.minecraft.wooden_axe": "houten bijl□□wanneer in hoofdhand:□+6 aanvalsschade□-3.2 aanvalssnelheid",
  "item.minecraft.stone_sword": "stenen zwaard□□wanneer in hoofdhand:□+4 aanvalsschade□-2.4 aanvalssnelheid",
  "item.minecraft.stone_shovel": "stenen schup□□wanneer in hoofdhand:□+2.5 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.stone_pickaxe": "stenen houweel□□wanneer in hoofdhand:□+2 aanvalsschade□-2.8 aanvalssnelheid",
  "item.minecraft.stone_axe": "stenen bijl□□wanneer in hoofdhand:□+8 aanvalsschade□-3.2 aanvalssnelheid",
  "item.minecraft.diamond_sword": "diamanten zwaard□□wanneer in hoofdhand:□+6 aanvalsschade□-2.4 aanvalssnelheid",
  "item.minecraft.diamond_shovel": "diamanten schup□□wanneer in hoofdhand:□+4.5 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.diamond_pickaxe": "diamanten houweel□□wanneer in hoofdhand:□+4 aanvalsschade□-2.8 aanvalssnelheid",
  "item.minecraft.diamond_axe": "diamanten bijl□□wanneer in hoofdhand:□+8 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.stick": "stok",
  "item.minecraft.bowl": "kom",
  "item.minecraft.mushroom_stew": "paddenstoelenstoofpot",
  "item.minecraft.golden_sword": "gouden zwaard□□wanneer in hoofdhand:□+3 aanvalsschade□-2.4 aanvalssnelheid",
  "item.minecraft.golden_shovel": "gouden schup□□wanneer in hoofdhand:□+1.5 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.golden_pickaxe": "gouden houweel□□wanneer in hoofdhand:□+1 aanvalsschade□-2.8 aanvalssnelheid",
  "item.minecraft.golden_axe": "gouden bijl□□wanneer in hoofdhand:□+6 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.netherite_sword": "netherieten zwaard□□wanneer in hoofdhand:□+7 aanvalsschade□-2.4 aanvalssnelheid",
  "item.minecraft.netherite_shovel": "netherieten schep□□wanneer in hoofdhand:□+5.5 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.netherite_pickaxe": "netherieten houweel□□wanneer in hoofdhand:□+5 aanvalsschade□-2.8 aanvalssnelheid",
  "item.minecraft.netherite_axe": "netherieten bijl□□wanneer in hoofdhand:□+9 aanvalsschade□-3 aanvalssnelheid",
  "item.minecraft.string": "draad",
  "item.minecraft.feather": "veer",
  "item.minecraft.gunpowder": "buskruit",
  "item.minecraft.wooden_hoe": "houten schoffel□□wanneer in hoofdhand:□-3 aanvalssnelheid",
  "item.minecraft.stone_hoe": "stenen schoffel□□wanneer in hoofdhand:□-2 aanvalssnelheid",
  "item.minecraft.iron_hoe": "ijzeren schoffel□□wanneer in hoofdhand:□-1 aanvalssnelheid",
  "item.minecraft.diamond_hoe": "diamanten schoffel□□wanneer in hoofdhand:",
  "item.minecraft.golden_hoe": "gouden schoffel□□wanneer in hoofdhand:□-3 aanvalssnelheid",
  "item.minecraft.netherite_hoe": "netherieten schoffel□□wanneer in hoofdhand:",
  "item.minecraft.wheat_seeds": "tarwezaden",
  "item.minecraft.wheat": "tarwe",
  "item.minecraft.bread": "brood",
  "item.minecraft.leather_helmet": "leren kap□□wanneer op het hoofd:□+1 harnas",
  "item.minecraft.leather_chestplate": "leren tuniek□□wanneer op het lichaam:□+3 harnas",
  "item.minecraft.leather_leggings": "leren broek□□wanneer op de benen:□+2 harnas",
  "item.minecraft.leather_boots": "leren laarzen□□wanneer op de voeten:□+1 harnas",
  "item.minecraft.chainmail_helmet": "maliënkap□□wanneer op het hoofd:□+2 harnas",
  "item.minecraft.chainmail_chestplate": "maliënkolder□□wanneer op het lichaam:□+5 harnas",
  "item.minecraft.chainmail_leggings": "maliënbroek□□wanneer op de benen:□+4 harnas",
  "item.minecraft.chainmail_boots": "maliënlaarzen□□wanneer op de voeten:□+1 harnas",
  "item.minecraft.iron_helmet": "ijzeren helm□□wanneer op het hoofd:□+2 harnas",
  "item.minecraft.iron_chestplate": "ijzeren borstplaat□□wanneer op het lichaam:□+6 harnas",
  "item.minecraft.iron_leggings": "ijzeren beenstukken□□wanneer op de benen:□+5 harnas",
  "item.minecraft.iron_boots": "ijzeren laarzen□□wanneer op de voeten:□+2 harnas",
  "item.minecraft.diamond_helmet": "diamanten helm□□wanneer op het hoofd:□+3 harnas□+2 harnashardheid",
  "item.minecraft.diamond_chestplate": "diamanten borstplaat□□wanneer op het lichaam:□+8 harnas□+2 harnashardheid",
  "item.minecraft.diamond_leggings": "diamanten beenstukken□□wanneer op de benen:□+6 harnas□+2 harnashardheid",
  "item.minecraft.diamond_boots": "diamanten laarzen□□wanneer op de voeten:□+3 harnas□+2 harnashardheid",
  "item.minecraft.golden_helmet": "gouden helm□□wanneer op het hoofd:□+2 harnas",
  "item.minecraft.golden_chestplate": "gouden borstplaat□□wanneer op het lichaam:□+5 harnas",
  "item.minecraft.golden_leggings": "gouden beenstukken□□wanneer op de benen:□+3 harnas",
  "item.minecraft.golden_boots": "gouden laarzen□□wanneer op de voeten:□+1 harnas",
  "item.minecraft.netherite_helmet": "netherieten helm□□wanneer op het hoofd:□+3 harnas□+3 harnashardheid□+1 terugslagsweerstand",
  "item.minecraft.netherite_chestplate": "netherieten borstplaat□□wanneer op het lichaam:□+8 harnas□+3 harnashardheid□+1 terugslagsweerstand",
  "item.minecraft.netherite_leggings": "netherieten beenstukken□□wanneer op de benen:□+6 harnas□+3 harnashardheid□+1 terugslagsweerstand",
  "item.minecraft.netherite_boots": "netherieten laarzen□□wanneer op de voeten:□+3 harnas□+3 harnashardheid□+1 terugslagsweerstand",
  "item.minecraft.flint": "vuursteen",
  "item.minecraft.porkchop": "rauw varkensvlees",
  "item.minecraft.cooked_porkchop": "gebraden varkensvlees",
  "item.minecraft.painting": "schilderij",
  "item.minecraft.golden_apple": "gouden appel",
  "item.minecraft.enchanted_golden_apple": "betoverde gouden appel",
  "block.minecraft.oak_sign": "eiken bord",
  "block.minecraft.spruce_sign": "sparren bord",
  "block.minecraft.birch_sign": "berken bord",
  "block.minecraft.jungle_sign": "oerwoud bord",
  "block.minecraft.acacia_sign": "acacia bord",
  "block.minecraft.dark_oak_sign": "donkereiken bord",
  "block.minecraft.crimson_sign": "helrood bord",
  "block.minecraft.warped_sign": "spookachtig bord",
  "item.minecraft.bucket": "emmer",
  "item.minecraft.water_bucket": "emmer water",
  "item.minecraft.lava_bucket": "emmer lava",
  "item.minecraft.minecart": "mijnkar",
  "item.minecraft.saddle": "zadel",
  "item.minecraft.redstone": "redstonestof",
  "item.minecraft.snowball": "sneeuwbal",
  "item.minecraft.oak_boat": "eikenhouten boot",
  "item.minecraft.leather": "leer",
  "item.minecraft.milk_bucket": "emmer melk",
  "item.minecraft.pufferfish_bucket": "emmer met kogelvis",
  "item.minecraft.salmon_bucket": "emmer met zalm",
  "item.minecraft.cod_bucket": "emmer met kabeljauw",
  "item.minecraft.tropical_fish_bucket": "emmer met tropische vis",
  "item.minecraft.brick": "baksteen",
  "item.minecraft.clay_ball": "kleibal",
  "block.minecraft.dried_kelp_block": "gedroogd kelpblok",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "boek",
  "item.minecraft.slime_ball": "slijmbal",
  "item.minecraft.chest_minecart": "mijnkar met kist",
  "item.minecraft.furnace_minecart": "mijnkar met oven",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "vishengel",
  "item.minecraft.clock": "klok",
  "item.minecraft.glowstone_dust": "gloeisteenstof",
  "item.minecraft.cod": "rauwe kabeljauw",
  "item.minecraft.salmon": "rauwe zalm",
  "item.minecraft.tropical_fish": "tropische vis",
  "item.minecraft.pufferfish": "kogelvis",
  "item.minecraft.cooked_cod": "gebakken kabeljauw",
  "item.minecraft.cooked_salmon": "gebakken zalm",
  "item.minecraft.ink_sac": "inktzak",
  "item.minecraft.red_dye": "rode kleurstof",
  "item.minecraft.green_dye": "groene kleurstof",
  "item.minecraft.cocoa_beans": "cacaobonen",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "paarse kleurstof",
  "item.minecraft.cyan_dye": "cyaan kleurstof",
  "item.minecraft.light_gray_dye": "lichtgrijze kleurstof",
  "item.minecraft.gray_dye": "grijze kleurstof",
  "item.minecraft.pink_dye": "roze kleurstof",
  "item.minecraft.lime_dye": "limoengroene kleurstof",
  "item.minecraft.yellow_dye": "gele kleurstof",
  "item.minecraft.light_blue_dye": "lichtblauwe kleurstof",
  "item.minecraft.magenta_dye": "magenta kleurstof",
  "item.minecraft.orange_dye": "oranje kleurstof",
  "item.minecraft.bone_meal": "beendermeel",
  "item.minecraft.blue_dye": "blauwe kleurstof",
  "item.minecraft.brown_dye": "bruine kleurstof",
  "item.minecraft.black_dye": "zwarte kleurstof",
  "item.minecraft.white_dye": "witte kleurstof",
  "item.minecraft.bone": "bot",
  "item.minecraft.sugar": "suiker",
  "block.minecraft.cake": "taart",
  "block.minecraft.white_bed": "wit bed",
  "block.minecraft.orange_bed": "oranje bed",
  "block.minecraft.magenta_bed": "magenta bed",
  "block.minecraft.light_blue_bed": "lichtblauw bed",
  "block.minecraft.yellow_bed": "geel bed",
  "block.minecraft.lime_bed": "limoengroen bed",
  "block.minecraft.pink_bed": "roze bed",
  "block.minecraft.gray_bed": "grijs bed",
  "block.minecraft.light_gray_bed": "lichtgrijs bed",
  "block.minecraft.cyan_bed": "cyaan bed",
  "block.minecraft.purple_bed": "paars bed",
  "block.minecraft.blue_bed": "blauw bed",
  "block.minecraft.brown_bed": "bruin bed",
  "block.minecraft.green_bed": "groen bed",
  "block.minecraft.red_bed": "rood bed",
  "block.minecraft.black_bed": "zwart bed",
  "item.minecraft.cookie": "koekje",
  "item.minecraft.filled_map": "kaart□#0",
  "item.minecraft.shears": "schaar",
  "item.minecraft.melon_slice": "meloenschijf",
  "item.minecraft.dried_kelp": "gedroogde kelp",
  "item.minecraft.pumpkin_seeds": "pompoenpitten",
  "item.minecraft.melon_seeds": "meloenzaden",
  "item.minecraft.beef": "rauwe biefstuk",
  "item.minecraft.cooked_beef": "biefstuk",
  "item.minecraft.chicken": "rauwe kip",
  "item.minecraft.cooked_chicken": "gebraden kip",
  "item.minecraft.rotten_flesh": "bedorven vlees",
  "item.minecraft.ender_pearl": "enderparel",
  "item.minecraft.blaze_rod": "blazestaf",
  "item.minecraft.ghast_tear": "ghasttraan",
  "item.minecraft.gold_nugget": "goudklompje",
  "item.minecraft.nether_wart": "netherkruid",
  "item.minecraft.potion": "onmaakbare drank□geen effecten",
  "item.minecraft.glass_bottle": "glazen fles",
  "item.minecraft.spider_eye": "spinnenoog",
  "item.minecraft.fermented_spider_eye": "gefermenteerd spinnenoog",
  "item.minecraft.blaze_powder": "blazepoeder",
  "item.minecraft.magma_cream": "magmacrème",
  "block.minecraft.brewing_stand": "brouwstandaard",
  "block.minecraft.cauldron": "ketel",
  "item.minecraft.ender_eye": "enderoog",
  "item.minecraft.glistering_melon_slice": "glinsterende meloenschijf",
  "item.minecraft.bat_spawn_egg": "vleermuizenspawnei",
  "item.minecraft.bee_spawn_egg": "bijenspawnei",
  "item.minecraft.blaze_spawn_egg": "blazespawnei",
  "item.minecraft.cat_spawn_egg": "kattenspawnei",
  "item.minecraft.cave_spider_spawn_egg": "grottenspinnenspawnei",
  "item.minecraft.chicken_spawn_egg": "kippenspawnei",
  "item.minecraft.cod_spawn_egg": "kabeljauwspawnei",
  "item.minecraft.cow_spawn_egg": "koeienspawnei",
  "item.minecraft.creeper_spawn_egg": "creeperspawnei",
  "item.minecraft.dolphin_spawn_egg": "dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "ezelspawnei",
  "item.minecraft.drowned_spawn_egg": "drenkelingspawnei",
  "item.minecraft.elder_guardian_spawn_egg": "oudebewakerspawnei",
  "item.minecraft.enderman_spawn_egg": "endermannenspawnei",
  "item.minecraft.endermite_spawn_egg": "endermitespawnei",
  "item.minecraft.evoker_spawn_egg": "oproeperspawnei",
  "item.minecraft.fox_spawn_egg": "vossenspawnei",
  "item.minecraft.ghast_spawn_egg": "ghastspawnei",
  "item.minecraft.guardian_spawn_egg": "bewakerspawnei",
  "item.minecraft.hoglin_spawn_egg": "hoglinspawnei",
  "item.minecraft.horse_spawn_egg": "paardenspawnei",
  "item.minecraft.husk_spawn_egg": "mummiespawnei",
  "item.minecraft.llama_spawn_egg": "lamaspawnei",
  "item.minecraft.magma_cube_spawn_egg": "magmakubusspawnei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroomspawnei",
  "item.minecraft.mule_spawn_egg": "muilezelspawnei",
  "item.minecraft.ocelot_spawn_egg": "ocelottenspawnei",
  "item.minecraft.panda_spawn_egg": "pandaspawnei",
  "item.minecraft.parrot_spawn_egg": "papegaaienspawnei",
  "item.minecraft.phantom_spawn_egg": "fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "varkenspawnei",
  "item.minecraft.piglin_spawn_egg": "piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "plunderaarspawnei",
  "item.minecraft.polar_bear_spawn_egg": "ijsberenspawnei",
  "item.minecraft.pufferfish_spawn_egg": "kogelvissenspawnei",
  "item.minecraft.rabbit_spawn_egg": "konijnenspawnei",
  "item.minecraft.ravager_spawn_egg": "vernielerspawnei",
  "item.minecraft.salmon_spawn_egg": "zalmspawnei",
  "item.minecraft.sheep_spawn_egg": "schapenspawnei",
  "item.minecraft.shulker_spawn_egg": "shulkerspawnei",
  "item.minecraft.silverfish_spawn_egg": "zilvervissenspawnei",
  "item.minecraft.skeleton_spawn_egg": "skelettenspawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "skeletpaardenspawnei",
  "item.minecraft.slime_spawn_egg": "slijmkubusspawnei",
  "item.minecraft.spider_spawn_egg": "spinnenspawnei",
  "item.minecraft.squid_spawn_egg": "inktvissenspawnei",
  "item.minecraft.stray_spawn_egg": "verdwaaldenspawnei",
  "item.minecraft.strider_spawn_egg": "lavarijderspawnei",
  "item.minecraft.trader_llama_spawn_egg": "handelaarslamaspawnei",
  "item.minecraft.tropical_fish_spawn_egg": "tropischevissenspawnei",
  "item.minecraft.turtle_spawn_egg": "schildpaddenspawnei",
  "item.minecraft.vex_spawn_egg": "ergernissenspawnei",
  "item.minecraft.villager_spawn_egg": "dorpelingenspawnei",
  "item.minecraft.vindicator_spawn_egg": "verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "zwervende handelaarspawnei",
  "item.minecraft.witch_spawn_egg": "heksenspawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelettenspawnei",
  "item.minecraft.wolf_spawn_egg": "wolvenspawnei",
  "item.minecraft.zoglin_spawn_egg": "zoglinspawnei",
  "item.minecraft.zombie_spawn_egg": "zombiespawnei",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepaardenspawnei",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedorpelingenspawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombiepiglinspawnei",
  "item.minecraft.experience_bottle": "magiërsextract",
  "item.minecraft.fire_charge": "vuurbal",
  "item.minecraft.writable_book": "boek en veer",
  "item.minecraft.written_book": "geschreven boek",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "voorwerplijst",
  "block.minecraft.flower_pot": "bloempot",
  "item.minecraft.carrot": "wortel",
  "item.minecraft.potato": "patat",
  "item.minecraft.baked_potato": "gebakken patat",
  "item.minecraft.poisonous_potato": "giftige patat",
  "item.minecraft.map": "lege kaart",
  "item.minecraft.golden_carrot": "gouden wortel",
  "block.minecraft.skeleton_skull": "skelettenschedel",
  "block.minecraft.wither_skeleton_skull": "witherskelettenschedel",
  "block.minecraft.player_head": "speler hoofd",
  "block.minecraft.zombie_head": "zombiehoofd",
  "block.minecraft.creeper_head": "creeperhoofd",
  "block.minecraft.dragon_head": "drakenhoofd",
  "item.minecraft.carrot_on_a_stick": "wortel aan een stok",
  "item.minecraft.warped_fungus_on_a_stick": "spookachtige zwam aan een stok",
  "item.minecraft.nether_star": "netherster",
  "item.minecraft.pumpkin_pie": "pompoentaart",
  "item.minecraft.firework_rocket": "vuurpijl",
  "item.minecraft.firework_star": "vuurwerkster",
  "item.minecraft.enchanted_book": "betoverd boek",
  "item.minecraft.nether_brick": "netherbakstenen",
  "item.minecraft.quartz": "netherkwarts",
  "item.minecraft.tnt_minecart": "mijnkar met tnt",
  "item.minecraft.hopper_minecart": "mijnkar met trechter",
  "item.minecraft.prismarine_shard": "prismarienscherf",
  "item.minecraft.prismarine_crystals": "prismarienkristallen",
  "item.minecraft.rabbit": "rauw konijnenvlees",
  "item.minecraft.cooked_rabbit": "gebraden konijnenvlees",
  "item.minecraft.rabbit_stew": "konijnenstoofpot",
  "item.minecraft.rabbit_foot": "konijnenpootje",
  "item.minecraft.rabbit_hide": "konijnenhuid",
  "item.minecraft.armor_stand": "harnashouder",
  "item.minecraft.iron_horse_armor": "ijzeren paardenharnas",
  "item.minecraft.golden_horse_armor": "gouden paardenharnas",
  "item.minecraft.diamond_horse_armor": "diamanten paardenharnas",
  "item.minecraft.leather_horse_armor": "leren paardenharnas",
  "item.minecraft.lead": "leidtouw",
  "item.minecraft.name_tag": "naamkaartje",
  "item.minecraft.command_block_minecart": "mijnkar met opdrachtblok",
  "item.minecraft.mutton": "rauw schapenvlees",
  "item.minecraft.cooked_mutton": "gebraden schapenvlees",
  "block.minecraft.white_banner": "witte vlag",
  "block.minecraft.orange_banner": "oranje vlag",
  "block.minecraft.magenta_banner": "magenta vlag",
  "block.minecraft.light_blue_banner": "lichtblauwe vlag",
  "block.minecraft.yellow_banner": "gele vlag",
  "block.minecraft.lime_banner": "limoengroene vlag",
  "block.minecraft.pink_banner": "roze vlag",
  "block.minecraft.gray_banner": "grijze vlag",
  "block.minecraft.light_gray_banner": "lichtgrijze vlag",
  "block.minecraft.cyan_banner": "cyaan vlag",
  "block.minecraft.purple_banner": "paarse vlag",
  "block.minecraft.blue_banner": "blauwe vlag",
  "block.minecraft.brown_banner": "bruine vlag",
  "block.minecraft.green_banner": "groene vlag",
  "block.minecraft.red_banner": "rode vlag",
  "block.minecraft.black_banner": "zwarte vlag",
  "item.minecraft.end_crystal": "endkristal",
  "item.minecraft.chorus_fruit": "chorusfruit",
  "item.minecraft.popped_chorus_fruit": "gepoft chorusfruit",
  "item.minecraft.beetroot": "biet",
  "item.minecraft.beetroot_seeds": "bietenzaden",
  "item.minecraft.beetroot_soup": "bietensoep",
  "item.minecraft.dragon_breath": "drakenadem",
  "item.minecraft.splash_potion": "spattende onmaakbare drank□geen effecten",
  "item.minecraft.spectral_arrow": "spectrale pijl",
  "item.minecraft.tipped_arrow": "onmaakbare getipte pijl□geen effecten",
  "item.minecraft.lingering_potion": "aanhoudende onmaakbare drank□geen effecten",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "dekschild",
  "item.minecraft.spruce_boat": "sparrenhouten boot",
  "item.minecraft.birch_boat": "berkenhouten boot",
  "item.minecraft.jungle_boat": "oerwoudhouten boot",
  "item.minecraft.acacia_boat": "acaciahouten boot",
  "item.minecraft.dark_oak_boat": "donkereikenhouten boot",
  "item.minecraft.totem_of_undying": "totem der onsterfelijkheid",
  "item.minecraft.shulker_shell": "shulkerschelp",
  "item.minecraft.iron_nugget": "ijzerklompje",
  "item.minecraft.knowledge_book": "boek der kennis",
  "item.minecraft.debug_stick": "debugstok",
  "item.minecraft.music_disc_13": "muziekplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "muziekplaat□c418 - cat",
  "item.minecraft.music_disc_blocks": "muziekplaat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muziekplaat□c418 - chirp",
  "item.minecraft.music_disc_far": "muziekplaat□c418 - far",
  "item.minecraft.music_disc_mall": "muziekplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muziekplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muziekplaat□c148 - stal",
  "item.minecraft.music_disc_strad": "muziekplaat□c148 - strad",
  "item.minecraft.music_disc_ward": "muziekplaat□c418 - ward",
  "item.minecraft.music_disc_11": "muziekplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "muziekplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muziekplaat□lena raine - pigstep",
  "item.minecraft.trident": "drietand□□wanneer in hoofdhand:□+8 aanvalsschade□-2.9 aanvalssnelheid",
  "item.minecraft.phantom_membrane": "fantoommembraan",
  "item.minecraft.nautilus_shell": "nautilusschelp",
  "item.minecraft.heart_of_the_sea": "hart van de zee",
  "item.minecraft.crossbow": "kruisboog",
  "item.minecraft.suspicious_stew": "verdachte stoofpot",
  "block.minecraft.loom": "weefgetouw",
  "item.minecraft.flower_banner_pattern": "vlagpatroon□bloemwapen",
  "item.minecraft.creeper_banner_pattern": "vlagpatroon□creeperwapen",
  "item.minecraft.skull_banner_pattern": "vlagpatroon□schedelwapen",
  "item.minecraft.mojang_banner_pattern": "vlagpatroon□mojangwapen",
  "item.minecraft.globe_banner_pattern": "vlagpatroon□aarde",
  "item.minecraft.piglin_banner_pattern": "vlagpatroon□snuit",
  "block.minecraft.composter": "composter",
  "block.minecraft.barrel": "vat",
  "block.minecraft.smoker": "roker",
  "block.minecraft.blast_furnace": "hoogoven",
  "block.minecraft.cartography_table": "cartografietafel",
  "block.minecraft.fletching_table": "pijlenmakerstafel",
  "block.minecraft.grindstone": "slijpsteen",
  "block.minecraft.lectern": "lezenaar",
  "block.minecraft.smithing_table": "smeedtafel",
  "block.minecraft.stonecutter": "steenhouwer",
  "block.minecraft.bell": "bel",
  "block.minecraft.lantern": "lantaarn",
  "block.minecraft.soul_lantern": "zielenlantaarn",
  "item.minecraft.sweet_berries": "zoete bessen",
  "block.minecraft.campfire": "kampvuur",
  "block.minecraft.soul_campfire": "zielenkampvuur",
  "block.minecraft.shroomlight": "zwammenlicht",
  "item.minecraft.honeycomb": "honingraat",
  "block.minecraft.bee_nest": "bijennest",
  "block.minecraft.beehive": "bijenkorf",
  "item.minecraft.honey_bottle": "honingfles",
  "block.minecraft.honey_block": "honingblok",
  "block.minecraft.honeycomb_block": "honingraatblok",
  "block.minecraft.lodestone": "zeilsteen",
  "block.minecraft.netherite_block": "netherietblok",
  "block.minecraft.ancient_debris": "oud puin",
  "block.minecraft.target": "doelwit",
  "block.minecraft.crying_obsidian": "huilend obsidiaan",
  "block.minecraft.blackstone": "zwartsteen",
  "block.minecraft.blackstone_slab": "zwartstenen plaat",
  "block.minecraft.blackstone_stairs": "zwartstenen trap",
  "block.minecraft.gilded_blackstone": "verguld zwartsteen",
  "block.minecraft.polished_blackstone": "gepolijst zwartsteen",
  "block.minecraft.polished_blackstone_slab": "gepolijste zwartstenen plaat",
  "block.minecraft.polished_blackstone_stairs": "gepolijste zwartstenen trap",
  "block.minecraft.chiseled_polished_blackstone": "gebeiteld gepolijst zwartsteen",
  "block.minecraft.polished_blackstone_bricks": "gepolijste zwartstenen blokstenen",
  "block.minecraft.polished_blackstone_brick_slab": "gepolijste zwartstenen blokstenen plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "gepolijste zwartstenen blokstenen trap",
  "block.minecraft.cracked_polished_blackstone_bricks": "gebarsten gepolijste zwartstenen blokstenen",
  "block.minecraft.respawn_anchor": "respawnanker",
}
export const nl_be = items; 
